import React from 'react';

import { NavLink, useLocation } from 'react-router-dom';

import { Navbar, Nav, Container } from 'react-bootstrap';

import './style.css';

import { useTranslation } from 'react-i18next';

import LanguageSwitcher from '../../../hook/LanguageSwitcher';

import ButtonTheme from '../../ui/ButtonTheme';
import { trackMatomoEvent } from '../../../utils/matomo';

const Header = () => {
  const { t } = useTranslation();

  const location = useLocation();

  const pathname = location.pathname.toLowerCase().replace(/\/+$/, '');

  const SOLID_ROUTES = ['/imprint', '/privacy-policy', '/cookie-policy'];

  const useImpressumClass = SOLID_ROUTES.some((r) => pathname.endsWith(r));
  const useTransparentClass = pathname === '/about';

  const projectsClassName = `nav-clean-link ${location.pathname === '/projects' ? 'is-active' : ''}`;

  const servicesClassName = `nav-clean-link ${location.pathname === '/services' ? 'is-active' : ''}`;

  const aboutClassName = `nav-clean-link ${location.pathname === '/about' ? 'is-active' : ''}`;

  const impactClassName = `nav-clean-link ${location.pathname === '/impact' ? 'is-active' : ''}`;

  return (
    <Navbar
      expand="lg"
      className={`nav-clean ${useImpressumClass ? 'nav-clean-solid' : ''} ${
        useTransparentClass ? 'nav-clean-transparent' : ''
      }`}
    >
      <Container className="nav-clean-inner">
        <Navbar.Brand
          as={NavLink}
          to="/"
          className="nav-clean-brand"
          onClick={() => trackMatomoEvent('Navigation', 'click', 'Header Home')}
        >
          <span className="nav-clean-brand-text">
            Blue<span>Alps</span>
          </span>
        </Navbar.Brand>

        <div className="nav-clean-right">
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="nav-clean-toggle"
          />
        </div>

        <Navbar.Collapse id="basic-navbar-nav" className="nav-clean-collapse">
          <Nav className="nav-clean-links">
            <Nav.Link
              as={NavLink}
              to="/about"
              className={aboutClassName}
              onClick={() =>
                trackMatomoEvent('Navigation', 'click', 'Header About')
              }
            >
              {t('header.about')}
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/services"
              className={servicesClassName}
              onClick={() =>
                trackMatomoEvent('Navigation', 'click', 'Header Services')
              }
            >
              {t('header.services')}
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/projects"
              className={projectsClassName}
              onClick={() =>
                trackMatomoEvent('Navigation', 'click', 'Header Projects')
              }
            >
              {t('header.projects')}
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/impact"
              className={impactClassName}
              onClick={() =>
                trackMatomoEvent('Navigation', 'click', 'Header Impact')
              }
            >
              {t('header.impact')}
            </Nav.Link>

            <div className="nav-clean-tools">
              <LanguageSwitcher />

              <ButtonTheme />
            </div>

            <Nav.Link
              as={NavLink}
              to="/contact"
              className="nav-clean-ctaWrap"
              onClick={() => trackMatomoEvent('CTA', 'click', 'Header contact')}
            >
              <span
                className={`nav-clean-cta ${location.pathname === '/contact' ? 'is-active' : ''}`}
              >
                {t('header.contact')}
              </span>
            </Nav.Link>
          </Nav>

          <div className="nav-clean-tools nav-clean-tools-mobile">
            <LanguageSwitcher />

            <ButtonTheme />
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
